import { styled, useTheme } from '@mui/material'
import { Avatar, AvatarProps } from '@carto/meridian-ds/components'
import { getCartoColorStylePropsForItem } from '@carto/meridian-ds/theme'
import { getColorIndex } from 'features/common/utils/colors'
import { Group } from 'features/groups'

const AvatarRoot = styled(Avatar)(() => ({
  textTransform: 'capitalize'
}))

function GroupAvatar({
  group,
  size = 'medium',
  disabled
}: {
  group: Group
  size?: AvatarProps['size']
  disabled?: boolean
}) {
  const theme = useTheme()

  const firstTwoLetters = group.customName.replace(/[^\w\s]/gi, '').substring(0, 2)

  return (
    <AvatarRoot
      style={getCartoColorStylePropsForItem(theme, getColorIndex(group.customName))}
      size={size}
      disabled={disabled}
    >
      {firstTwoLetters}
    </AvatarRoot>
  )
}

export default GroupAvatar
